import { CalendarOutlined, ExclamationCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Col, Modal, Row, Select, Space, Table, TableColumnsType, TableProps, Tag, Typography, message } from "antd";
import { useEffect, useState } from "react";
import { BsPencilSquare, BsTrashFill } from "react-icons/bs";
import {
  LoadingInformation,
  OptionFilter,
  Filter,
  initialInform,
  ControlException,
} from "src/entity/terminal-marketing/terminal-marketing.entity";
import useNavigationMenu from "src/hook/useNavigationMenu";
import {
  createLoadingInformation,
  deleteLoadingInformById,
  getLoadingInform,
  getOptions,
  getYear,
  updateLoadingInformation,
} from "src/services/terminal-marketing.service";
import { profileStore } from "src/stores/profile-store";
import { componentPalette } from "src/theme/component-palette";
import { useShallow } from "zustand/react/shallow";
import VocsModal from "src/components/Modal";
import SetupLoadingInfoModal from "./SetupLoadingInfoModal";
import { terminalStore } from "src/stores/terminal-store";
import { companyStore } from "src/stores/company-store";
import { CommonSuccess } from "src/entity/common/menus-enum.enum";
import VerticalCenter from "src/components/WrapCenter/VerticalCenter";
import { replaceUndefinedWithNull, trimAllKey } from "src/utils/utils-object";
import { convertedDateRangesFromFormat, covertedRangesDateToString } from "src/utils/date-time";
import { canEditTable, canViewTable } from "../../PermissionCheck/PermissionCheck";
import axios from "axios";
import { EmptyString } from "src/entity/common/unit.constant";
import Warning from "src/components/GlobalIconPart/Warning";
import "./SetupLoadingInfoTable.css";
import { generateYearArray } from "src/utils/array";
import { addCenterAlign } from "src/components/AntdCustomPart/TableTitle.tsx/TableTitle";

type OnChange = NonNullable<TableProps<any>["onChange"]>;
type Filters = Parameters<OnChange>[1];
const { Text } = Typography;

const SetupLoadingInfoTable = () => {
  const currentYear = new Date().getFullYear();
  const [companyId, setCompanyId] = useState<string>("");
  const profile = profileStore(useShallow((state) => state.profile));
  const loadingProfile = profileStore(useShallow((state) => state.loading));
  const { permissions } = useNavigationMenu();
  const [informs, setInforms] = useState<LoadingInformation[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedYear, setSelectedYear] = useState<number | null>(null);
  const [optionYears, setOptionYears] = useState<number[]>([]);
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState<number>(0);
  const [pageSize, setPageSize] = useState(10);
  const [filter, setFilter] = useState<Filters>({});
  const [optionsFilter, setOptionFilter] = useState<OptionFilter[]>([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [showModalLoadingInfo, setShowModalLoadingInfo] = useState(false);
  const [mode, setMode] = useState<"insert" | "update">("insert");
  const [informProps, setInformProps] = useState<LoadingInformation | null>(null);
  const [showModalError, setShowModalError] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [isDuplicate, setIsDuplicate] = useState<boolean>(false);

  const getChemicalProperty = terminalStore(useShallow((state) => state.getChemicalProperty));
  const chemicalPropertyMaster = terminalStore(useShallow((state) => state.chemicalProperty));

  const getLoadingMethod = terminalStore(useShallow((state) => state.getLoadingMethod));
  const loadingMethodMaster = terminalStore(useShallow((state) => state.loadingMethod));

  const getAreaByCompanyId = companyStore(useShallow((state) => state.getAreaByCompanyId));
  const areaMaster = companyStore(useShallow((state) => state.dataArea));

  const getEmissionControl = terminalStore(useShallow((state) => state.getEmissionControl));
  const emissionControlMaster = terminalStore(useShallow((state) => state.emissionControl));

  const fetchYear = () => {
    const years = generateYearArray();
    setOptionYears(years as number[]);
    setSelectedYear(years[0] as number);
  };

  const showDeleteConfirm = (value: LoadingInformation) => {
    const { _id } = value;
    VocsModal.delete({
      onOk: () => {
        if (_id) {
          deleteLoadingInform(_id);
        }
      },
    });
  };

  const onOpenModal = (mode: "insert" | "update", information: LoadingInformation) => {
    setShowModalLoadingInfo(true);
    setMode(mode);
    setInformProps(information);
    const arrayException = covertedRangesDateToString(information.controlExceptionDate as ControlException[]);
    information.arrControlExceptionDate = arrayException;
    if (information._id) {
      setSelectedId(information._id);
    }
  };

  const onChangeYear = (value: number) => {
    setSelectedYear(value);
  };

  const calPagination = (current?: number) => {
    if (current) {
      return (current - 1) * 10;
    }
  };

  const createParamFilter = () => {
    let queryParam = "";
    let offset = 0;
    let limit = pageSize;
    if (selectedYear) {
      queryParam += `year=${selectedYear}`;
    }
    if (current) {
      let resultCalOffset = calPagination(current);
      if (resultCalOffset) {
        offset = resultCalOffset;
      }
      queryParam += `&offset=${offset}`;
    }
    if (limit) {
      queryParam += `&limit=${limit}`;
    }

    if (filter) {
      const str = Object.entries(filter)
        .filter(([, value]) => value)
        .map(([key, value]) => `&${key}=[${value?.join(",")}]`)
        .join("");
      queryParam += str;
    }

    return queryParam;
  };

  const fetchLoadingInform = async () => {
    try {
      if (companyId && selectedYear) {
        setLoading(true);
        let offset = 0;
        let resultCalOffset = calPagination(current);
        if (resultCalOffset) {
          offset = resultCalOffset;
        }
        const query = createParamFilter();
        const response = await getLoadingInform(companyId, query);
        if (response.data.code === 200) {
          const data = response.data.data.informations;
          const total = response.data.data.total;
          let information = data.map((el: any, index: number) => {
            return {
              no: (index + offset + 1).toString(),
              ...el,
            };
          });
          if (canViewTable(permissions)) {
            setInforms([...information]);
            setTotal(total);
          } else {
            setInforms([]);
            setTotal(0);
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchOption = async () => {
    try {
      if (companyId && selectedYear) {
        const response = await getOptions(companyId, selectedYear);
        if (response.data.code === 200) {
          const data = response.data.data.filter;
          setOptionFilter(data);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const deleteLoadingInform = async (id: string) => {
    try {
      if (companyId) {
        setLoading(true);
        const response = await deleteLoadingInformById(companyId, id);
        if (response.data.code === 200) {
          messageApi.open({
            type: "success",
            content: CommonSuccess.DELETE_SUCCESSFULL,
          });
          fetchLoadingInform();
          fetchOption();
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveInformation = async (data: LoadingInformation, id: string) => {
    try {
      data = {
        ...data,
        year: selectedYear,
        companyId: companyId,
      };

      let response;
      setLoading(true);
      const formatData: any = trimAllKey(replaceUndefinedWithNull(data as any), []);
      const controlExceptionDate = formatData?.arrControlExceptionDate
        ? convertedDateRangesFromFormat(formatData.arrControlExceptionDate, "YYYY-MM-DD")
        : [];
      if (controlExceptionDate) {
        data = {
          ...data,
          controlExceptionDate,
        };
      }
      if (mode == "insert") {
        response = await createLoadingInformation(data);
      } else {
        if (id) {
          response = await updateLoadingInformation(id, data);
        }
      }
      if (response?.data.code === 200) {
        setLoading(false);
        messageApi.open({
          type: "success",
          content: CommonSuccess.SAVED_SUCCESSFULL,
        });
        fetchLoadingInform();
        fetchOption();
        setShowModalLoadingInfo(false);
        setIsDuplicate(false);
      } else {
        setIsDuplicate(false);
        setShowModalError(true);
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error?.response?.status === 409) {
          setIsDuplicate(true);
          setShowModalError(false);
        } else {
          setIsDuplicate(false);
          setShowModalError(true);
        }
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getMasterLabel = (type: string, text: string) => {
    if (!text || typeof text != "string") return "";
    if (type === "area" && areaMaster) {
      const optValue = areaMaster.find((item) => item._id === text);
      return optValue?.areaName;
    } else if (type === "chemicalId" && chemicalPropertyMaster) {
      const optValue = chemicalPropertyMaster.find((item) => item._id === text);
      return optValue?.chemicalName;
    } else if (type === "loadingById" && loadingMethodMaster) {
      const optValue = loadingMethodMaster.find((item) => item._id === text);
      return optValue?.loadingBy;
    } else if (type === "emissionControlId" && emissionControlMaster) {
      const optValue = emissionControlMaster.find((item) => item._id === text);
      return optValue?.emissionControl;
    } else if (type === "efficiency" && emissionControlMaster) {
      const optValue = emissionControlMaster.find((item) => item._id === text);
      return optValue?.efficiency;
    } else {
      return text;
    }
  };

  const mapFilter = (key: string): Filter[] | [] => {
    const resultFilter = optionsFilter.find((item) => item.key === key)?.filter;
    if (resultFilter) {
      const filter: Filter[] = resultFilter?.map((value: any) => {
        let text = value;
        if (key === "controlExceptionDate") {
          text = text === EmptyString ? "" : text;
        } else if (key === "area") {
          text = getMasterLabel("area", text);
        } else if (key === "chemicalId") {
          text = getMasterLabel("chemicalId", text);
        } else if (key === "loadingById") {
          text = getMasterLabel("loadingById", text);
        } else if (key === "emissionControlId") {
          text = getMasterLabel("emissionControlId", text);
        } else if (key === "efficiency") {
          text = getMasterLabel("efficiency", text);
        }
        return {
          text,
          value: value,
        };
      });
      return filter;
    } else {
      return [];
    }
  };

  const onTableChange: TableProps<LoadingInformation>["onChange"] = (pagination: any, filters: any) => {
    let current = pagination.current;
    setFilter(filters);
    setCurrent(current);
  };

  const initMaster = async () => {
    try {
      if (profile?.activeCompany?._id) {
        const query = "";
        await Promise.all([
          getChemicalProperty(query),
          getLoadingMethod(query),
          getEmissionControl(query),
          getAreaByCompanyId(profile?.activeCompany?._id),
        ]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const resetFilter = () => {
    setFilter({});
  };

  useEffect(() => {
    initMaster();
    fetchYear();
  }, []);

  useEffect(() => {
    if (profile?.activeCompany?._id) {
      setCompanyId(profile.activeCompany._id);
    }
    setCurrent(1);
  }, [profile?.activeCompany]);

  useEffect(() => {
    resetFilter();
    setCurrent(1);
  }, [selectedYear]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setSelectedYear(currentYear);
        if (companyId) {
          await Promise.all([getAreaByCompanyId(companyId), fetchLoadingInform(), fetchOption()]);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [companyId]);

  useEffect(() => {
    resetFilter();
  }, [selectedYear]);

  useEffect(() => {
    const fetchData = async () => {
      if (companyId && selectedYear) {
        await Promise.all([fetchLoadingInform(), fetchOption()]);
      }
    };
    fetchData();
  }, [current, filter]);

  const columns: TableColumnsType = [
    {
      title: "Chemical Name",
      dataIndex: "chemicalName",
      key: "chemicalId",
      filteredValue: filter?.chemicalId || null,
      filters: mapFilter("chemicalId"),
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Area",
      dataIndex: "area",
      filteredValue: filter?.area || null,
      filters: mapFilter("area"),
      render: (text) => <Text>{getMasterLabel("area", text)}</Text>,
    },
    {
      title: "Loading By",
      dataIndex: "loadingBy",
      key: "loadingById",
      filteredValue: filter?.loadingById || null,
      filters: mapFilter("loadingById"),
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Emission Control",
      dataIndex: "emissionControl",
      key: "emissionControlId",
      filteredValue: filter?.emissionControlId || null,
      filters: mapFilter("emissionControlId"),
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Efficiency (%)",
      dataIndex: "efficiency",
      filteredValue: filter?.efficiency || null,
      filters: mapFilter("efficiency"),
      render: (text) => <Text>{text}</Text>,
    },
    // {
    //   title: "Control Exception Date",
    //   dataIndex: "controlExceptionDate",
    //   width: 300,
    //   filteredValue: filter?.controlExceptionDate || null,
    //   filters: mapFilter("controlExceptionDate"),
    //   render: (ControlException: ControlException[]) => (
    //     <div>
    //       {ControlException?.map((item, index) => {
    //         return (
    //           <Row key={index + "period"} className={`bg-white-500 rounded-md ${index !== 0 ? "mt-2" : ""}`}>
    //             <Col span={22}>
    //               <Tag style={{ backgroundColor: "white", margin: 2, padding: 1 }}>
    //                 <Text className="p-1">
    //                   {item.startDate}
    //                   {" -> "}
    //                   {item.endDate}
    //                 </Text>
    //               </Tag>
    //             </Col>
    //             <Col span={2}>
    //               <VerticalCenter>
    //                 <CalendarOutlined style={{ fontSize: 18 }} />
    //               </VerticalCenter>
    //             </Col>
    //           </Row>
    //         );
    //       })}
    //     </div>
    //   ),
    // },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (value, record) => (
        <Space>
          <Button
            className="border-transparent bg-transparent"
            size={"small"}
            disabled={!canEditTable(permissions)}
            onClick={() => {
              onOpenModal("update", record);
            }}
          >
            <BsPencilSquare size={16} color={componentPalette.blueGrey} />
          </Button>
          <Button
            className="border-transparent bg-transparent"
            disabled={!canEditTable(permissions) || record.isFlowActive}
            onClick={() => showDeleteConfirm(value)}
          >
            {record.isFlowActive}
            <BsTrashFill size={16} color={componentPalette.blueGrey} />
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Modal
        open={showModalError}
        maskClosable={true}
        width={550}
        onCancel={() => setShowModalError(false)}
        title={
          <span>
            <ExclamationCircleOutlined style={{ color: "red", marginRight: "15px", fontSize: "25px" }} />
            Cannot save the data
          </span>
        }
        footer={
          <div style={{ display: "flex", justifyContent: "center", paddingTop: "10px" }}>
            <Button
              type="primary"
              style={{
                backgroundColor: componentPalette.primary,
              }}
              onClick={() => setShowModalError(false)}
            >
              OK
            </Button>
          </div>
        }
      >
        <div style={{ paddingLeft: "30px" }}>
          <p>• Vestibulum et urna venenatis, venenatis arcu nec, accumsan diam.</p>
          <p>• Suspendisse id ante nec dui fringilla tempor sit amet ac dui.</p>
          <p>• Maecenas ac felis pulvinar, consequat orci eget, accumsan mauris.</p>
          <p>• Vestibulum dapibus elit nec elit accumsan pretium.</p>
          <p>• Aenean tincidunt arcu eu diam ornare elementum a at nisi.</p>
        </div>
      </Modal>

      {showModalLoadingInfo && informProps && emissionControlMaster && chemicalPropertyMaster && loadingMethodMaster && (
        <SetupLoadingInfoModal
          open={showModalLoadingInfo}
          id={selectedId}
          mode={mode}
          initialData={informProps}
          loading={loading}
          companyId={companyId}
          chemicalPropertyMaster={chemicalPropertyMaster}
          loadingMethodMaster={loadingMethodMaster}
          emissionControlMaster={emissionControlMaster}
          areaMaster={areaMaster}
          isDuplicate={isDuplicate}
          onSave={(data, id) => handleSaveInformation(data, id)}
          onDuplicateChange={(isDup) => {
            setIsDuplicate(isDup);
          }}
          onCloseModal={() => {
            setIsDuplicate(false);
            setShowModalLoadingInfo(false);
          }}
        />
      )}
      <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "10px" }}>
        <Select
          value={selectedYear}
          style={{ width: 120 }}
          onChange={onChangeYear}
          options={optionYears.map((year) => ({ label: year, value: year }))}
          loading={loading}
          size="middle"
        />
        {contextHolder}
        <Button
          type="primary"
          size="middle"
          onClick={() => onOpenModal("insert", initialInform)}
          style={{
            display: "flex",
            alignItems: "center",
            visibility: canEditTable(permissions) ? "visible" : "hidden",
          }}
          loading={loading}
        >
          <PlusCircleOutlined />
          New
        </Button>
      </div>

      <Table
        className="w-full whitespace-nowrap"
        columns={addCenterAlign(columns)}
        rowKey="_id"
        scroll={{ x: "max-content" }}
        dataSource={informs}
        pagination={{
          size: "small",
          current,
          pageSize,
          total,
          showSizeChanger: false,
        }}
        onChange={onTableChange}
        loading={loading || loadingProfile}
        rowClassName={(record) => (record.isWarning == true ? "red-border-row" : "")}
      />
    </div>
  );
};

export default SetupLoadingInfoTable;
